import Router, { Route, Switch } from '@alltrails/shared/components/ReactRouter';
import { Context } from '@alltrails/shared/types/context';
import ApplicationLayout from 'components/ApplicationLayout/ApplicationLayout';
import CustomProvider from 'components/CustomProvider';
import PlusLandingPage from 'components/LandingPages/PlusLandingPage';
import Coupon from 'types/Coupon';
import CurrencyCode from 'types/CurrencyCode';
import Plan from 'types/Plan';
import { UserId } from '@alltrails/shared/types/User';
import PodcastLandingPage from 'components/LandingPages/PodcastLandingPage';
import PetSmartLandingPage from 'components/LandingPages/PetSmartLandingPage';
import MerchLandingPage from 'components/LandingPages/MerchLandingPage';
import TiktokLandingPage from 'components/LandingPages/TiktokLandingPage';
import CheckoutRoute from './CheckoutRoute';
import LoginRoute from './LoginRoute';
import RegisterRoute from './RegisterRoute';

type ProRouterProps = {
  annualPlan: Plan;
  context: Context;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  currentPage: string;
  locationSlug: string;
  planTypes: Plan[];
  userId?: UserId;
  whenExpired: string;
  wideFooter: boolean;
};

function ProRouter({
  currencyCode,
  coupon,
  annualPlan,
  planTypes,
  userId,
  currentPage,
  locationSlug,
  context,
  whenExpired,
  wideFooter
}: ProRouterProps) {
  return (
    <Router fullpath={global.__AT_DATA__.pathname}>
      <Switch>
        <Route path="/:locale?/signup">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <RegisterRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/login">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <LoginRoute coupon={coupon} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/pro">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <PlusLandingPage coupon={coupon} currencyCode={currencyCode} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/podcast">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <PodcastLandingPage coupon={coupon} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/merch">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <MerchLandingPage planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/petsmart">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <PetSmartLandingPage coupon={coupon} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route exact path="/:locale?/tiktok">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <TiktokLandingPage coupon={coupon} planTypes={planTypes} userId={userId} currencyCode={currencyCode} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/pro/checkout">
          <CheckoutRoute
            annualPlan={annualPlan}
            coupon={coupon}
            currencyCode={currencyCode}
            plans={planTypes}
            userId={userId}
            whenExpired={whenExpired}
          />
        </Route>
        <Route exact path="/:locale?/plus">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <PlusLandingPage coupon={coupon} currencyCode={currencyCode} planTypes={planTypes} userId={userId} />
          </ApplicationLayout>
        </Route>
        <Route path="/:locale?/plus/checkout">
          <CheckoutRoute
            annualPlan={annualPlan}
            coupon={coupon}
            currencyCode={currencyCode}
            plans={planTypes}
            userId={userId}
            whenExpired={whenExpired}
          />
        </Route>
        <Route path="/:locale?/plus/signup">
          <ApplicationLayout context={context} currentPage={currentPage} locationSlug={locationSlug} wideFooter={wideFooter}>
            <RegisterRoute />
          </ApplicationLayout>
        </Route>
      </Switch>
    </Router>
  );
}

type Props = {
  annualPlan: Plan;
  // layout props
  context: Context;
  coupon?: Coupon;
  currencyCode: CurrencyCode;
  currentPage: string;
  locationSlug: string;
  planTypes: Plan[];
  userId?: UserId;
  wideFooter: boolean;
  whenExpired: string;
};

export default function Pro({
  context,
  planTypes,
  currencyCode,
  coupon,
  annualPlan,
  userId,
  wideFooter,
  currentPage,
  locationSlug,
  whenExpired
}: Props) {
  return (
    <CustomProvider>
      <ProRouter
        annualPlan={annualPlan}
        context={context}
        coupon={coupon}
        currencyCode={currencyCode}
        currentPage={currentPage}
        locationSlug={locationSlug}
        planTypes={planTypes}
        userId={userId}
        whenExpired={whenExpired}
        wideFooter={wideFooter}
      />
    </CustomProvider>
  );
}
